import { Route, Routes } from 'react-router-dom';
import Login from 'pages/login';
import SignUp from 'pages/signup';
import CustomBackdrop from 'components/cmn/CustomBackdrop';
import CustomMessage from 'components/cmn/CustomMessage';
import CustomDialog from 'components/dialog/CustomDialog';
import ReduxStateSaver from 'components/cmn/ReduxStateSaver';
import AdminPage from 'pages/admin';
import ProjectOverview from 'pages/admin/project/overview';
import MemberManagement from 'pages/admin/member-management';
import DiagnosticManagement from 'pages/admin/diagnostic-management';
import AdminAccount from 'pages/admin/account';
import ProjectCreate from 'pages/admin/project/create';
import ProjectEnterInformation from 'pages/admin/project/enter-information';
import ProjectManagement from 'pages/admin/project/management';
import MemberProjectManagement from 'pages/admin/member-management/id';
import DiagnosticRegist from 'pages/admin/diagnostic-management/regist';
import DiagnosticInfo from 'pages/admin/diagnostic-management/id';
import ManagerPage from 'pages/manager';
import ManagerProject from 'pages/manager/member-management';
import ManagerProjectManagement from 'pages/manager/project/management';
import ParticipationPage from 'pages/participations';
import InspectionPage from 'pages/inspection';
import MindPage from 'pages/mind';
import SurveyPage from 'pages/survey';
import SurveyResultPage from 'pages/surveyResult';
import ExternalRegisterPage from 'pages/external-register';

function App(): JSX.Element {
  return (
    <>
      <CustomBackdrop />
      <CustomMessage />
      <CustomDialog />
      <ReduxStateSaver />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin/signup" element={<SignUp />} />
        <Route path="admin" element={<AdminPage />}>
          <Route path="account" element={<AdminAccount />} />
          <Route path="project">
            <Route path="overview" element={<ProjectOverview />} />
            <Route path="create" element={<ProjectCreate />} />
            <Route path="enter-information" element={<ProjectEnterInformation />} />
            <Route path="management" element={<ProjectManagement />} />
          </Route>
          <Route path="member-management" element={<MemberManagement />} />
          <Route path="member-management/:id" element={<MemberProjectManagement />} />
          <Route path="diagnostic-management" element={<DiagnosticManagement />} />
          <Route path="diagnostic-management/regist" element={<DiagnosticRegist />} />
          <Route path="diagnostic-management/:id" element={<DiagnosticInfo />} />
        </Route>
        <Route path="manager" element={<ManagerPage />}>
          <Route path="member-management" element={<ManagerProject />} />
          <Route path="project">
            <Route path="management" element={<ManagerProjectManagement />} />
          </Route>
        </Route>
        <Route path="mind" element={<MindPage />}>
          <Route path="projects/:projectId/:participationCode" element={<ParticipationPage />} />
          <Route path="classification" element={<InspectionPage />} />
          <Route path="survey" element={<SurveyPage />} />
          <Route path="survey/result" element={<SurveyResultPage />} />
        </Route>
        <Route path="external/register/:projectId" element={<ExternalRegisterPage />} />
      </Routes>
    </>
  );
}

export default App;
